<template>
  <div class="home-top">
    <div
      class="home-top-bg"
      :style="{ background: bg_list[bg_index] }"
    />
    <header v-if="sogouApp">
      <a
        v-show="false"
        id="goback"
        href="javascript:history.go(-1)"
        uigs="head_back"
        class="back"
      />
      <h1>搜狗视频</h1>
      <a
        v-if="showBarrierFree"
        class="sgapp-easy-access"
        href="javascript:void(0);"
        onclick="aria.start()"
        clickhide="false"
        openText="打开无障碍"
        closeText="关闭无障碍"
      >无障碍</a>
    </header>
    <header
      v-else
      class="header-home"
    >
      <a
        v-show="false"
        id="goback"
        href="javascript:history.go(-1)"
        uigs="head_back"
        class="back"
      />
      <a
        :href="hotSuggHref"
        uigs="head_search"
        class="search-input"
      >
        <span>{{ placeholder }}</span>
        <span class="txt">搜索</span>
      </a>
      <a
        v-if="showBarrierFree"
        class="easy-access"
        href="javascript:void(0);"
        onclick="aria.start()"
        clickhide="false"
        openText="打开无障碍"
        closeText="关闭无障碍"
      >无障碍</a>
    </header>
    <banner-item
      v-if="banner && banner.length > 0"
      :list="banner"
      @change="bannerChange"
    />
    <ul
      v-if="nav && nav.length > 0"
      class="home-nav"
    >
      <li
        v-for="(item, index) in nav"
        :key="index"
      >
        <a
          :href="item.playurl"
          :uigs="'out_home_tag_' + index"
          :class="item.icon"
        >
          <h4>{{ item.tag_name }}</h4>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import BannerItem from './BannerItem';

export default {
  components: { BannerItem },
  props: {
    banner: {
      type: Array,
      default: () => [],
    },
    nav: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isSpver: this.$route.query.spver === '1',
      bg_index: 0,
      bg_list: [
        'radial-gradient(circle,rgba(155,162,178,1) 0%,rgba(28,38,54,1) 100%)',
        'radial-gradient(circle,rgba(208,164,150,1) 0%,rgba(32,18,30,1) 100%)',
        'radial-gradient(circle,rgba(142,142,142,1) 0%,rgba(10,10,10,1) 100%)',
        'radial-gradient(circle,rgba(212,196,172,1) 0%,rgba(48,38,28,1) 100%)',
        'radial-gradient(circle,rgba(152,184,198,1) 0%,rgba(2,28,32,1) 100%)',
      ],
      sogouApp: false,
    };
  },
  computed: {
    ...mapState('common', ['$config']),
    placeholder() {
      return this.isSpver ? '请输入搜索关键词' : '搜狗视频';
    },
    hotSuggHref() {
      return `/hotsugg${this.isSpver ? '?spver=1' : ''}`;
    },
    showBarrierFree() {
      const { userAgent = '', isHitBarrierFree } = this.$config || {};
      return !userAgent.toLowerCase().includes('vivobrowser') && isHitBarrierFree;
    },
  },
  mounted() {
    if (history.length > 0 && document.referrer) {
      document.querySelector('.back').style.display = 'block';
    }
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('sogousearch') >= 0 && ua.indexOf('nohead') >= 0) {
      this.sogouApp = true;
    }
  },
  methods: {
    bannerChange(index) {
      const len = this.bg_list.length;
      this.bg_index = index < len ? index : index % len;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_home.scss';
header {
  height: 56px;
  padding: 0;
  color: #fff;
  font-size: 15px;
  position: relative;
  display: block;

  h1 {
    text-align: center;
    line-height: 56px;
  }

  .sgapp-easy-access {
    position: absolute;
    line-height: 56px;
    font-size: 13px;
    right: 0;
    top: 0;
    color: #fff;
  }

  .back {
    @include sprite-item('home/back');
    @extend %-vertical-center;
    left: 0;
    z-index: 9999;
  }
  .search {
    @include sprite-item('home/search');
    @extend %-vertical-center;
    right: 6px;
  }
}

.header-home {
  height: 38px;
  padding: 14px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  a {
    color: #fff;
    line-height: 38px;
    font-size: 15px;
  }

  .back {
    width: 21px;
    position: relative;
    &:after {
      content: '';
      display: block;
      @include sprite-item('home/back');
      @extend %-vertical-center;
      z-index: 9999;
    }
  }

  .search-input {
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 20px;
    color: rgba(255, 255, 255, 0.5);
    z-index: 30;
    position: relative;
    padding-left: 40px;
    flex: auto;
    display: flex;
    align-items: center;

    .txt {
      color: #fff;
      margin-left: auto;
      padding: 0 16px;
      line-height: 16px;
      height: 16px;
      border-left: 1px solid rgba(255, 255, 255, 0.2);
      @include line-clip(1);
    }

    &:before {
      content: '';
      @include sprite-item('home/search');
      @extend %-vertical-center;
      left: 9px;
      display: inline-block;
      z-index: 20;
    }
  }

  .easy-access {
    margin-left: 7px;
    opacity: 0.5;
  }
}

.home-top {
  padding: 0 14px 22px;
  position: relative;
  margin-bottom: 7px;
  overflow: hidden;

  &:before,
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    @include sprite-item('home/arc');
    z-index: 1;
    html[data-theme='dark'] & {
      height: 0px;
    }
  }
  &:before {
    left: 0;
  }
  &:after {
    right: 0;
    transform: scaleX(-1);
  }

  .home-top-bg {
    position: absolute;
    left: 0;
    top: -160%;
    width: 100%;
    height: 300%;
    transition: all 1s;
    z-index: -1;
  }
}

.home-nav {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  padding: 16px 5px 0;
  > li {
    width: 48px;
    position: relative;

    a {
      display: block;
      &:before {
        content: '';
        display: block;
        width: 48px;
        height: 48px;
      }
    }

    .film {
      &:before {
        @include sprite-item('home/icon_film');
      }
    }
    .tvshow {
      &:before {
        @include sprite-item('home/icon_tvshow');
      }
    }
    .teleplay {
      &:before {
        @include sprite-item('home/icon_teleplay');
      }
    }
    .cartoon {
      &:before {
        @include sprite-item('home/icon_cartoon');
      }
    }
    .record {
      &:before {
        @include sprite-item('home/icon_record');
      }
    }

    h4 {
      width: 100%;
      color: #fff;
      text-align: center;
      line-height: 19px;
      font-size: 13px;
      @include line-clip(1);
    }
  }
}

.home-footer {
  border-top: 8px solid #f5f5f5;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
